<template>
  <el-dialog
    title="Выбор типа реестра для скачивания"
    :visible.sync="visibleModal"
    :width="isMobile ? '90%' : '900px'"
    class="add-registry-dialog"
    append-to-body
    :before-close="handleClose"
    :close-on-click-modal="false"
    @open="getDataBeforeOpen"
  >
    <el-dialog
      width="80%"
      :title="innerTitle"
      :visible.sync="innerVisible"
      append-to-body
    >
      <el-image :src="url" lazy />
    </el-dialog>
    <loader-wrapper :loading="loading">
      <el-steps
        :space="200"
        :active="active"
        simple
        style="margin-bottom: 32px; font-family: 'Mulish', sans-serif"
      >
        <el-step title="Тип реестра" icon="el-icon-edit" />
        <el-step title="Получатели" icon="el-icon-user" />
      </el-steps>
      <el-row v-if="active === 1" style="margin-bottom: 24px">
        <el-radio-group v-model="type" class="df fd-column">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-card
                v-for="reg in Object.values(registryOptions).slice(
                  0,
                  Object.values(registryOptions).length / 2,
                )"
                :key="reg.text"
                shadow="hover"
                class="registerCard"
              >
                <el-radio :label="reg.text">
                  <span class="title">{{ reg.name }}</span>
                </el-radio>
                <el-button
                  type="warning"
                  icon="el-icon-view"
                  circle
                  style="padding: 6px; margin-left: 0"
                  @click="showImage(reg.file, reg.name)"
                />
              </el-card>
            </el-col>
            <el-col :span="12">
              <el-card
                v-for="reg in Object.values(registryOptions).slice(
                  Object.values(registryOptions).length / 2,
                )"
                :key="reg.text"
                shadow="hover"
                style="
                  padding: 4px;
                  margin-bottom: 12px;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                <el-radio :label="reg.text">
                  <span class="title">{{ reg.name }}</span>
                </el-radio>

                <el-button
                  type="warning"
                  icon="el-icon-view"
                  circle
                  style="padding: 6px; margin-left: 0"
                  @click="showImage(reg.file, reg.name)"
                />
              </el-card>
            </el-col>
          </el-row>
        </el-radio-group>
      </el-row>

      <el-row v-if="active === 2" :gutter="24" style="margin-bottom: 24px">
        <el-col>
          <el-form
            ref="sendForm"
            :model="sendForm"
            :rules="rules"
            class="demo-ruleForm"
          >
            <el-row style="margin-bottom: 24px">
              <el-form-item prop="registry_email_main">
                <p class="label-item">Получатель</p>
                <el-input
                  v-model="sendForm['registry_email_main']"
                  placeholder="Введите email"
                />
              </el-form-item>

              <div v-for="(item, index) in sendForm.other" :key="index">
                <div class="col">
                  <el-form-item
                    :prop="'other.' + index + '.email'"
                    :rules="{
                      type: 'email',
                      message: 'Введите корректный email  адрес',
                      trigger: ['blur', 'change'],
                    }"
                  >
                    <p class="label-item">
                      {{ `Дополнительный получатель ${index + 1}` }}
                    </p>
                    <el-input
                      v-model="item.email"
                      placeholder="Введите email"
                    />
                  </el-form-item>
                </div>
              </div>
              <el-button :disabled="loading" type="secondary" @click="addRow">
                Добавить еще получателя
              </el-button>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
      <el-row
        v-if="registry_fields_meta && registry_fields_meta['user_id']"
        :gutter="24"
        style="margin-bottom: 24px"
      >
        <el-col :span="12">
          <p class="label-item">
            Измененно:
            <span style="color: #e6a23c; font-weight: bold">
              {{ registry_fields_meta.created_at }}
            </span>
          </p>
        </el-col>
        <el-col :span="12">
          <p class="label-item">
            Пользователь:
            <span style="color: #e6a23c; font-weight: bold">
              {{
                registry_fields_meta['user_fio']
                  ? registry_fields_meta['user_fio']
                  : registry_fields_meta['user_id']
              }}
            </span>
          </p>
          <p class="label-item">
            Телефон:
            <span style="color: #e6a23c; font-weight: bold">
              +
              {{ registry_fields_meta['user_login'] }}
            </span>
          </p>
        </el-col>
      </el-row>

      <el-row class="ta-r">
        <el-button v-if="active === 2" :disabled="loading" @click="active--">
          Назад
        </el-button>

        <el-button
          :loading="loading"
          :disabled="loading"
          type="primary"
          @click="active === 2 ? submitForm('sendForm') : active++"
        >
          {{ active === 2 ? 'Сохранить' : 'Далее' }}
        </el-button>
      </el-row>
    </loader-wrapper>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { registryOptions } from './constants'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

const registryBidRepository = RepositoryFactory.get('registryBidRepository')

export default {
  name: 'AddRegistryType',
  components: { LoaderWrapper },
  props: {
    reportBid: {
      type: Number,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sendForm: {
        registry_email_main: '',
        other: [],
      },
      registry_fields_meta: null,
      active: 1,
      url: null,
      registryOptions,
      loading: true,
      innerVisible: false,
      type: 'registry_ast',
      innerTitle: null,
      rules: {
        registry_email_main: [
          {
            required: true,
            message: 'Введите email  адрес',
            trigger: 'blur',
          },
          {
            type: 'email',
            message: 'Введите корректный email  адрес',
            trigger: ['blur', 'change'],
          },
        ],
      },
    }
  },
  computed: {
    visibleModal() {
      return this.visible
    },
  },

  methods: {
    addRow() {
      this.sendForm.other.push({
        email: '',
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true
          let listOtherUser = ''

          this.sendForm.other.map((item, index) => {
            if (index + 1 === this.sendForm.other.length) {
              listOtherUser += `${item.email}`
            } else {
              listOtherUser += `${item.email},`
            }
          })
          const dataResponse = {
            bid_id: this.reportBid,
            registry_template: this.type,
            registry_email_main: this.sendForm.registry_email_main,
            registry_email_cc: listOtherUser,
          }

          registryBidRepository
            .addRegistryToBid(dataResponse)
            .then(response => {
              this.$message({
                message: 'Реестр добавлен',
                type: 'success',
              })
              this.handleClose()
            })
            .catch(err => this.errHandler(err))
            .finally(() => (this.loading = false))
        } else {
          console.log('error submit!!')

          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    showImage(file, title) {
      this.url = file
      this.innerVisible = true
      this.innerTitle = title
    },
    handleClose() {
      this.$emit('close')
      this.registry_fields_meta = null
      this.active = 1
      this.type = null
      this.loading = true
      this.sendForm = {
        registry_email_main: '',
        other: [],
      }
    },
    getDataBeforeOpen() {
      registryBidRepository
        .getRegistry(this.reportBid)
        .then(response => {
          const {
            registry_email_main,
            registry_email_cc,
            registry_fields_meta,
            registry_template,
          } = response.data

          this.type = registry_template
          this.sendForm.registry_email_main = registry_email_main
          this.registry_fields_meta = registry_fields_meta
          registry_email_cc &&
            registry_email_cc
              .split(',')
              .filter(Boolean)
              .map(item => this.sendForm.other.push({ email: item }))
        })
        .catch(err => this.errHandler(err))
        .finally(() => (this.loading = false))
    },
  },
}
</script>

<style lang="sass">
.add-registry-dialog
  .el-dialog__header
    padding: 20px 40px
    color: #000
  .el-dialog__body
    padding: 0 40px 40px
    color: #000
  .el-radio
    display: flex
    width: 100%
    margin-right: 0
  .gap-30
    gap: 20px
  .el-form-item__error
    color: #F56C6C
    font-family: 'Mulish', sans-serif
    font-size: 12px
  .title
    font-family: 'Mulish', sans-serif
    font-size: 14px
    font-weight: bold
    color: rgba(0, 0, 0, 0.47)
  .image-slot
    position: relative
    top: 50%
  .registerCard
    padding: 4px
    margin-bottom: 12px
    display: flex
    align-items: center
    justify-content: space-between
  .el-card__body
    width: 100%
    display: flex
    align-items: center
    justify-content: space-between
  .label-item
    margin-bottom: 6px
    font-family: 'Mulish', sans-serif
</style>
